import * as generalTypes from '../types/generalTypes'

const initialState = {
  mode: localStorage.getItem('customer-mode'),
  promoCodes: null,
  productFiltersOffline: null,
  filteredUsers: null,
  productFiltersOnline: null,
  onlineFilteredUsers: null,
  totalPages: 1,
  totalSpent: 0,
  query: null,
  monitoringNames: null,
  vendorInfo: null,
  years: null,
  conversion: { positive: [], down: [] },
  customersBehaviour: { returningCustomers: [], newCustomers: [] },
}

const generalReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case generalTypes.CUSTOMERBEHAVIOUR:
      return {
        ...state,
        customersBehaviour: action.payload,
        // mode: "offline",
      }
    case generalTypes.CONVERSION:
      return {
        ...state,
        conversion: action.payload,
        // mode: "offline",
      }
    case generalTypes.SET_YEAR:
      return {
        ...state,
        years: action.payload,
        // mode: "offline",
      }
    case generalTypes.DEFAULT_CUSTOMER_MODE:
      return {
        ...state,
        mode: 'offline',
      }
    case 'VENDOR_INFO':
      return {
        ...state,
        vendorInfo: payload,
      }
    case generalTypes.OFFLINE_PRODUCT_FILTERS:
      return {
        ...state,
        productFiltersOffline: payload,
      }
    case generalTypes.MONITORING_NAMES:
      return {
        ...state,
        monitoringNames: payload,
      }
    case generalTypes.EMPTY_MONITORING_NAMES:
      return {
        ...state,
        monitoringNames: null,
      }
    case generalTypes.GET_TOTAL_PAGES:
      return {
        ...state,
        totalPages: payload,
      }
    case generalTypes.GET_TOTAL_SPENT:
      return {
        ...state,
        totalSpent: payload,
      }
    case generalTypes.GET_QUERY:
      return {
        ...state,
        query: payload,
      }
    case generalTypes.GET_AB_QUERY:
      return {
        ...state,
        ABquery: payload,
      }
    case generalTypes.GET_TOTAL_PAGES_LOYALTY:
      return {
        ...state,
        totalPagesLoyalty: payload,
      }

    case generalTypes.ONLINE_PRODUCT_FILTERS:
      return {
        ...state,
        productFiltersOnline: payload,
      }
    case generalTypes.OFFLINE_FILTERED_USERS:
      return {
        ...state,
        filteredUsers: payload,
      }
    case generalTypes.ONLINE_FILTERED_USERS:
      return {
        ...state,
        onlineFilteredUsers: payload,
      }
    case generalTypes.CUSTOMER_MODE:
      return {
        ...state,
        mode: payload,
      }
    // if (state.mode === "online") {
    //   localStorage.setItem("customer-mode", "offline");
    //   return {
    //     ...state,
    //     mode: "offline",
    //   };
    // } else {
    //   localStorage.setItem("customer-mode", "online");

    //   return {
    //     ...state,
    //     mode: "online",
    //   };
    // }
    case generalTypes.PROMO_CODES:
      return {
        ...state,
        promoCodes: payload,
      }
    default:
      return state
  }
}

export default generalReducer
